/* eslint-disable */

/*
Copyright (C) Philippe Meyer 2019
Distributed under the MIT License
https://github.com/PhilippeMarcMeyer/VanillaSelectBox
*/

import '../Sysmex/polyfills'

let VSBoxCounter = function () {
  let count = 0
  return {
    set: function () {
      return ++count
    }
  }
}()

export function VanillaSelectBox (el, options) {
  let self = this
  this.instanceOffset = VSBoxCounter.set()
  this.root = el
  this.main = false
  this.opener = false
  this.title = false
  this.resetAll = false
  this.close = false
  this.menu = false
  this.top = false
  this.left = false
  this.options = false
  this.listElements = false
  this.isDisabled = this.root.classList.contains(`${options.prefix}_isDisabled`)
  this.search = false
  this.searchZone = null
  this.inputBox = null
  this.ulminWidth = 140
  this.ulminHeight = 25
  this.userOptions = {
    maxWidth: 500,
    maxHeight: 400,
    search: false,
    prefix: '',
    searchInputPlaceholder: '',
    placeHolder: '',
    resetLabel: '',
    closeLabel: '',
    submitOnClose: '',
    closeOnClickOutside: '',
    closeOnReset: '',
    submitOnCloseCallback: null
  }
  if (options) {
    if (options.maxWidth !== undefined) {
      this.userOptions.maxWidth = options.maxWidth
    }
    if (options.maxHeight !== undefined) {
      this.userOptions.maxHeight = options.maxHeight
    }
    if (options.placeHolder !== undefined) {
      this.userOptions.placeHolder = options.placeHolder
    }
    if (options.search !== undefined) {
      this.search = options.search
    }
    if (options.searchInputPlaceholder !== undefined) {
      this.userOptions.searchInputPlaceholder = options.searchInputPlaceholder
    }
    if (options.prefix !== undefined) {
      this.userOptions.prefix = options.prefix
    }
    if (options.resetLabel !== undefined) {
      this.userOptions.resetLabel = options.resetLabel
    }
    if (options.closeLabel !== undefined) {
      this.userOptions.closeLabel = options.closeLabel
    }
    if (options.submitOnClose !== undefined) {
      this.userOptions.submitOnClose = options.submitOnClose
    }
    if (options.submitOnClose !== undefined) {
      this.userOptions.closeOnClickOutside = options.closeOnClickOutside
    }
    if (options.closeOnReset !== undefined) {
      this.userOptions.closeOnReset = options.closeOnReset
    }
    if (options.submitOnCloseCallback !== undefined) {
      this.userOptions.submitOnCloseCallback = options.submitOnCloseCallback
    }
  }

  this.init = function () {
    let self = this
    // create main element
    this.main = document.createElement('div')
    // append main element to root element
    this.root.appendChild(this.main)
    this.main.classList.add(`${this.userOptions.prefix}_main`)

    // create button select opener, this has to a button for accessibility
    this.opener = document.createElement('button')

    this.main.appendChild(this.opener)
    // create title element, this can be a placeholder or a list of select option labels
    this.title = document.createElement('div')
    this.opener.appendChild(this.title)

    this.title.classList.add(`${this.userOptions.prefix}_title`)
    // initially this will be a placeholder
    this.title.classList.add(`${this.userOptions.prefix}_placeHolder`)

    // position for the menu
    let rect = this.opener.getBoundingClientRect()
    this.top = rect.bottom
    this.left = rect.left
    // create menu wrapper element
    this.menu = document.createElement('div')
    this.main.appendChild(this.menu)
    this.menu.classList.add(`${this.userOptions.prefix}_menu`)
    this.menu.style.zIndex = 2000 - this.instanceOffset
    // create the menu list
    this.ul = document.createElement('ul')
    this.menu.appendChild(this.ul)

    this.ul.style.minWidth = this.ulminWidth + 'px'
    this.ul.style.minHeight = this.ulminHeight + 'px'

    this.ul.classList.add(`${this.userOptions.prefix}_multi`)

    let selectedTexts = ''
    let sep = ''
    let nrActives = 0

    this.optionsSelected = false

    this.bottomNav = document.createElement('div')
    this.bottomNav.classList.add(`${this.userOptions.prefix}_bottom-nav`)

    // if theres a reset label option
    if (this.userOptions.resetLabel) {
      this.resetAll = document.createElement('div')
      this.resetAll.classList.add(`${this.userOptions.prefix}_reset-all`)
      this.resetAll.textContent = this.userOptions.resetLabel
      // reset selection on resetAll callback
      this.resetAll.addEventListener('click', function (e) {
        e.stopPropagation()
        // only if its active
        if(e.currentTarget.classList.contains(`${self.userOptions.prefix}_reset-all-active`)) {
          self.empty()

          if(self.userOptions.closeOnReset) {
            closeByUser()
          }
        }
      })
      // add to bottom nav element
      this.bottomNav.appendChild(this.resetAll)
    }

    // if theres a closelabel option
    if (this.userOptions.closeLabel) {
      this.close = document.createElement('div')
      this.close.classList.add(`${this.userOptions.prefix}_close`)
      this.close.textContent = this.userOptions.closeLabel
      // if close label then close the select
      this.close.addEventListener('click', function (e) {
        e.stopPropagation()
        closeByUser()
      })
      // add to bottom nav element
      this.bottomNav.appendChild(this.close)
    }

    this.bottomNav.addEventListener('click', function (e) {
      e.stopPropagation()
    })

    // add bottom nav element to menu wrapper
    this.menu.appendChild(this.bottomNav)

    // get all options
    this.options = el.querySelectorAll('option')
    const options = Array.prototype.slice.call(this.options)
    // get all selected options and filter alphabetically
    const selectedOptions = options.filter(a => (a.selected && !a.disabled)).sort((a, b) => (a.textContent < b.textContent ? -1 : 1))
    // get all not selected options and filter alphabetically
    const unselectedOptions = options.filter(a => (!a.selected && !a.disabled)).sort((a, b) => (a.textContent < b.textContent ? -1 : 1))
    // get all disabled options and filter alphabetically
    const disabledOptions = options.filter(a => (a.disabled)).sort((a, b) => (a.textContent < b.textContent ? -1 : 1))

    // concat all select and not selected options so the select ones will be at the top sorted alphetically while the unselected one come below also sorted alphabetically
    const sortedOptions = selectedOptions.concat(unselectedOptions).concat(disabledOptions)


    if(selectedOptions.length) {
      this.resetAll.classList.add(`${this.userOptions.prefix}_reset-all-active`)
      this.title.classList.remove(`${this.userOptions.prefix}_placeHolder`)
    }

    // add option behavior
    sortedOptions.forEach(function (x) {
      let text = x.textContent
      let value = x.value

      let li = document.createElement('li')

      li.addEventListener('click', selectOptionHandler)

      let isSelected = x.hasAttribute('selected')
      self.ul.appendChild(li)
      li.setAttribute('data-value', value)
      li.setAttribute('data-text', text)
      li.classList.add(`${self.userOptions.prefix}_option`)

      if (x.disabled) {
        li.classList.add(`${self.userOptions.prefix}_disabled`)
      }

      if (isSelected) {
        nrActives++
        selectedTexts += sep + text
        sep = ', '
        li.classList.add(`${self.userOptions.prefix}_active`)
      }

      const textWrapper = document.createElement('span')
      textWrapper.classList.add(`${self.userOptions.prefix}_text-wrapper`)
      textWrapper.appendChild(document.createTextNode(text))
      li.appendChild(textWrapper)
    })

    self.title.innerHTML = selectedTexts

    if (self.userOptions.placeHolder !== '' && self.title.textContent === '') {
      self.title.textContent = self.userOptions.placeHolder
    }

    if (self.search) {
        buildSearch()
    }

    function handleOutsideClick (event) {
      if (self.root && !self.root.contains(event.target) && !event.defaultPrevented) {
        closeByUser()
      }
    }

    this.main.addEventListener('click', function (e) {

      e.preventDefault()
      e.stopPropagation()

      if(self.isDisabled || self.closeMultiSelect()) {
        return;
      }

      closeAllMultiSelects();

      setTimeout(function(){
        self.menu.querySelector(`.${self.userOptions.prefix}_search-input`).focus()
      }, 100);

      if (window.innerWidth < 550) {
        document.querySelector('body').style.overflow = 'hidden'
      }

      const options = Array.prototype.slice.call(self.ul.querySelectorAll('li'))
      const selectedOptions = options.filter(a => (a.classList.contains(`${self.userOptions.prefix}_active`) && !a.classList.contains(`${self.userOptions.prefix}_disabled`))).sort((a, b) => (a.textContent < b.textContent ? -1 : 1))

      // if (selectedOptions) {
        const unselectedOptions = options.filter(a => (!a.classList.contains(`${self.userOptions.prefix}_active`) && !a.classList.contains(`${self.userOptions.prefix}_disabled`))).sort((a, b) => (a.textContent < b.textContent ? -1 : 1))
        const disabledOptions = options.filter(a => (a.classList.contains(`${self.userOptions.prefix}_disabled`))).sort((a, b) => (a.textContent < b.textContent ? -1 : 1))
        const sortedOptions = selectedOptions.concat(unselectedOptions).concat(disabledOptions)

        while (self.ul.hasChildNodes()) {
          self.ul.removeChild(self.ul.firstChild);
        }

        sortedOptions.forEach(function (x) {
          self.ul.appendChild(x)
        })
      // }

      self.menu.style.left = 0 + 'px'
      self.menu.scrollTop = 0
      if (window.innerWidth > 550) {
        self.menu.style.top = e.currentTarget.offsetHeight + 'px'
        document.addEventListener('click', self.closeMultiSelect)
      }
      self.main.classList.add(`${self.userOptions.prefix}_open`)

      // if (self.userOptions.closeOnClickOutside) {
      //   document.addEventListener('click', handleOutsideClick, true)
      // }

    })

    function buildSearch () {
      self.listElements = self.menu.querySelectorAll(`.${self.userOptions.prefix}_option`)
      self.searchZone = document.createElement('div')
      self.searchZone.classList.add(`${self.userOptions.prefix}_search-zone`)
      self.searchZone.style.zIndex = 2001 - self.instanceOffset
      self.inputBox = document.createElement('input')
      self.inputBox.setAttribute('autocomplete', 'off');
      self.inputBox.classList.add(`${self.userOptions.prefix}_search-input`)
      self.searchZone.appendChild(self.inputBox)
      self.menu.insertBefore(self.searchZone, self.menu.firstChild)
      self.inputBox.setAttribute('type', 'text')
      self.inputBox.setAttribute('placeholder', self.userOptions.searchInputPlaceholder)

      self.searchZone.addEventListener('click', function (e) {
        e.stopPropagation()
      })

      self.ul.addEventListener('scroll', function () {
        if (window.innerWidth > 450) {
          const y = this.scrollTop
          self.searchZone.parentNode.style.top = y + 'px'
        }
      })

      self.inputBox.addEventListener('keyup', function (e) {
        let searchValue = e.target.value.toUpperCase()
        let searchValueLength = searchValue.length
        if (searchValueLength < 2) {
          Array.prototype.slice.call(self.listElements).forEach(function (x) {
            x.classList.remove(`${self.userOptions.prefix}_hide`)
          })
        } else {
          Array.prototype.slice.call(self.listElements).forEach(function (x) {
            let text = x.getAttribute('data-text').toUpperCase()
            if (text.indexOf(searchValue) === -1) {
              x.classList.add(`${self.userOptions.prefix}_hide`)
            } else {
              x.classList.remove(`${self.userOptions.prefix}_hide`)
            }
          })
        }
      })
    }

    function selectOptionHandler (e) {
      if (self.isDisabled) return

      if (!self.optionsSelected && self.userOptions.closeOnClickOutside) {
        document.addEventListener('click', handleOutsideClick, true)
        self.optionsSelected = true
      }

      let choiceValue = this.getAttribute('data-value')
      let className = this.getAttribute('class')

      let wasActive = false
      if (className) {
        wasActive = className.indexOf('active') !== -1
      }
      if (wasActive) {
        this.classList.remove(`${self.userOptions.prefix}_active`)
      } else {
        this.classList.add(`${self.userOptions.prefix}_active`)
      }
      let selectedTexts = ''
      let sep = ''
      let nrActives = 0
      let nrAll = 0
      for (let i = 0; i < self.options.length; i++) {
        nrAll++
        if (self.options[i].value === choiceValue) {
          self.options[i].selected = !wasActive
        }
        if (self.options[i].selected) {
          nrActives++
          selectedTexts += sep + self.options[i].textContent
          sep = ', '
        }
      }
      self.title.textContent = selectedTexts
      self.privateSendChange()

      e.preventDefault()
      e.stopPropagation()
      if (self.userOptions.placeHolder !== '' && self.title.textContent === '') {
        self.title.textContent = self.userOptions.placeHolder
      }

      const options = Array.prototype.slice.call(self.ul.querySelectorAll('li'))
      const selectedOptions = options.filter(a => (a.classList.contains(`${self.userOptions.prefix}_active`))).sort((a, b) => (a.textContent < b.textContent ? -1 : 1))

      if(selectedOptions.length) {
        self.resetAll.classList.add(`${self.userOptions.prefix}_reset-all-active`)
        self.title.classList.remove(`${self.userOptions.prefix}_placeHolder`)
      } else {
        self.resetAll.classList.remove(`${self.userOptions.prefix}_reset-all-active`)
        self.title.textContent = self.userOptions.placeHolder
        self.title.classList.add(`${self.userOptions.prefix}_placeHolder`)
      }
    }


    function closeByUser () {
      if (self.userOptions.submitOnClose) {
        const parentForm = self.main.previousElementSibling.form
        if (parentForm) {
          if (self.userOptions.submitOnCloseCallback) {
            self.userOptions.submitOnCloseCallback()
          }
          parentForm.requestSubmit()
        }
      }
      self.closeMultiSelect()

      if (self.userOptions.closeOnClickOutside) {
        document.removeEventListener('click', handleOutsideClick, true) // would be better positioned inside self.closeMultiSelect
        self.optionsSelected = false
      }
    }

    function closeAllMultiSelects () {
      const prefix = self.userOptions.prefix;
      const multiSelects = Array.prototype.slice.call(document.querySelectorAll(`.${prefix}`))
      multiSelects.forEach(function (multiSelect) {
        if(multiSelect !== el) {
          multiSelect.closeMultiSelect()
        }
      })
    }
  }

  this.closeMultiSelect = function() {

    if(!self.main.classList.contains(`${self.userOptions.prefix}_open`)) {
      return false;
    }

    document.removeEventListener('click', self.closeMultiSelect)
    self.main.classList.remove(`${self.userOptions.prefix}_open`)
    self.inputBox.value = ''
    Array.prototype.slice.call(self.listElements).forEach(function (x) {
      x.classList.remove(`${self.userOptions.prefix}_hide`)
    })
    document.querySelector('body').style.overflow = 'visible'
    const options = Array.prototype.slice.call(self.options)
    const selectedOptions = options.filter(a => (a.selected))
    if(selectedOptions.length) {
      self.title.classList.remove(`${self.userOptions.prefix}_placeHolder`);
    } else {
      self.title.classList.add(`${self.userOptions.prefix}_placeHolder`);
    }

    return true;

  }

  this.root.closeMultiSelect = this.closeMultiSelect

  this.init()
}



VanillaSelectBox.prototype.privateSendChange = function () {
  let event = document.createEvent('HTMLEvents')
  event.initEvent('change', true, false)
  this.root.dispatchEvent(event)
}

VanillaSelectBox.prototype.empty = function () {
  const prefix = this.userOptions.prefix
  Array.prototype.slice.call(this.listElements).forEach(function (x) {
    x.classList.remove(`${prefix}_active`)
  })

  const ul = this.ul;
  const options = Array.prototype.slice.call(this.listElements)
  const sortedOptions = options.sort((a, b) => (a.textContent < b.textContent ? -1 : 1))

  this.resetAll.classList.remove(`${this.userOptions.prefix}_reset-all-active`)

  while (ul.hasChildNodes()) {
    ul.removeChild(ul.firstChild);
  }
  sortedOptions.forEach(function (x) {
    ul.appendChild(x)
  })

  this.title.classList.add(`${this.userOptions.prefix}_placeHolder`);

  Array.prototype.slice.call(this.options).forEach(function (x) {
    x.selected = false
  })
  this.title.textContent = ''
  if (this.userOptions.placeHolder !== '' && this.title.textContent === '') {
    this.title.textContent = this.userOptions.placeHolder
  }
  this.privateSendChange()
}

